import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Car, ClipboardList, FileText, Package, Search, Truck } from "lucide-react";
import { api } from "@/lib/api";

const ICON = { vehicle: Car, issue: ClipboardList, document: FileText, supplier: Truck, part_order: Package };

export function GlobalSearch() {
  const [q, setQ] = useState("");
  const [res, setRes] = useState([]);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const box = useRef();
  useEffect(() => {
    if (q.trim().length < 2) { setRes([]); return; }
    const t = setTimeout(() => api.get("/search", { params: { q } }).then((r) => { setRes(r.data); setOpen(true); }), 200);
    return () => clearTimeout(t);
  }, [q]);
  useEffect(() => {
    const onKey = (e) => { if ((e.metaKey || e.ctrlKey) && e.key === "k") { e.preventDefault(); box.current?.focus(); } };
    window.addEventListener("keydown", onKey); return () => window.removeEventListener("keydown", onKey);
  }, []);
  const go = (r) => { setOpen(false); setQ(""); navigate(r.path); };
  return (
    <div className="relative w-full max-w-md">
      <Search className="pointer-events-none absolute left-3 top-2.5 h-4 w-4 text-muted-foreground" />
      <input ref={box} data-testid="global-search-input" className="fv-input h-9 pl-9" placeholder="Search vehicles, issues, documents, parts… (⌘K)" value={q} onChange={(e) => setQ(e.target.value)} onFocus={() => res.length && setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)} />
      {open && res.length > 0 && (
        <ul className="fv-card absolute z-30 mt-1 max-h-80 w-full overflow-auto p-1 border border-border" data-testid="global-search-results">
          {res.map((r) => { const I = ICON[r.type] || Search; return <li key={`${r.type}-${r.id}`}><button onMouseDown={() => go(r)} data-testid={`search-result-${r.type}-${r.id}`} className="fv-dense-row w-full text-left"><I className="h-4 w-4 text-muted-foreground" /><span className="min-w-0 flex-1 truncate"><span className="font-medium">{r.title}</span> <span className="text-muted-foreground">· {r.subtitle}</span></span><span className="fv-caption">{r.type.replace("_", " ")}</span></button></li>; })}
        </ul>
      )}
    </div>
  );
}
